import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarDays } from 'lucide-react';
import { motion } from 'framer-motion';
import api from '../../utils/api';

function E_Events() {
  const [holidays, setHolidays] = useState([]);
  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    api.get(`/api/holidays`)
      .then(res => setHolidays(res.data))
      .catch(err => console.error("Failed to fetch holidays", err));
  }, [baseUrl]);

  return (
    <div className="sm:p-6 sm:mt-auto mt-8 am:mb-auto mb-20 w-full mx-auto">

       <motion.div
        className="flex items-center gap-3 mb-6 bg-blue-100 rounded-xl p-4 sm:p-5 shadow-sm border border-slate-200"
        transition={{ duration: 0.4, type: "spring" }}
      >
         <div className='flex items-center gap-4 text-xl xs:text-2xl font-bold truncate'>
                  <div className='p-2 rounded-xl bg-slate-700 text-slate-100'><CalendarDays className="text-2xl" /></div>
                 
                <h2 className="text-xl xs:text-2xl font-bold">Holidays</h2>
                </div>


      </motion.div>
      <div className="bg-white rounded-xl shadow-md p-6">
        

        {holidays.length > 0 ? (
          <ul className="divide-y divide-gray-200">
            {holidays.map((holiday, i) => (
              <motion.li
                key={i}
                className="py-4 flex items-center justify-between"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
              >
                <span className="text-gray-700 font-medium">{holiday.holidayName}</span>
                <span className="text-sm text-gray-500">
                  {new Date(holiday.holidayDate).toLocaleDateString('en-IN', {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                  })}
                </span>
              </motion.li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-gray-400 py-8">
            <span className="text-5xl mb-2 block">📅</span>
            <p className="text-base font-medium">No holidays scheduled yet</p>
            <p className="text-sm mt-1 text-gray-300">Stay tuned for upcoming events.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default E_Events;
